import { css } from '@emotion/css';
import { minScreen } from 'utils/mediaQueries';
import { Color } from 'utils/variables';
import { buttonInteraction } from 'utils/mixin';

export const body = css(
  buttonInteraction,
  css`
  width: 219px;
  height: 56px;
  position: fixed;
  right: 24px;
  bottom: 38px;
  background: linear-gradient(147.36deg, #F3696E 21.73%, #F8A902 133.08%);
  border: 2px solid ${Color.White};
  border-radius: 200px;
  box-sizing: border-box;
  color: ${Color.White};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-family: 'Hiragino Kaku Gothic Pro';
  z-index: 9999;
  ${minScreen('md')} {
    width: 236px;
    height: 62px;
  }
`
);

export const icon = css`
  margin-right: 14px;
  fill: ${Color.White};
  ${minScreen('md')} {
    margin-right: 11px;
  }
`;